import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '@services/otherProjects.service';
import { textareaTextToArrayWithParams } from '@utils/utils';

export const fetch_other_projects = createAsyncThunk(
  'other_projects/fetch_other_projects',
  async (_, thunkAPI) => {
    try {
      const response = await Api.get_other_projects();
      return response.data;
    } catch {
      return [];
    }
  },
);

export const fetch_other_project = createAsyncThunk(
  'other_projects/fetch_other_project',
  async (slug, thunkAPI) => {
    try {
      const response = await Api.get_other_project(slug);
      return response.data;
    } catch {
      return {};
    }
  },
);

export const otherProjectsSlice = createSlice({
  name: 'other_projects',
  initialState: {
    other_projects: [],
    other_project: {},
    is_fetching_other_projects: false,
    is_fetching_other_project: false,
  },
  reducers: {
    setOtherProjects: (state, action) => {
      state.other_projects = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch_other_projects.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return {
              id: item.id,
              slug: item.slug,
              ...item.acf,
              videos: textareaTextToArrayWithParams(item.acf.videos),
            };
          });
        }

        const childrenMap = {};
        fetchedData.forEach((item) => {
          if (item.has_children) {
            childrenMap[item.id] = item.child_item;
          }
        });

        fetchedData.forEach((item) => {
          if (childrenMap[item.id]) {
            item.items = fetchedData.filter((child) =>
              childrenMap[item.id].includes(child.id),
            );
          }
        });

        fetchedData = fetchedData.filter(
          (item) => !Object.values(childrenMap).flat().includes(item.id),
        );
        state.other_projects = fetchedData;
        state.is_fetching_other_projects = false;
      })
      .addCase(fetch_other_projects.pending, (state) => {
        state.is_fetching_other_projects = true;
      })
      .addCase(fetch_other_projects.rejected, (state) => {
        state.is_fetching_other_projects = false;
      })
      .addCase(fetch_other_project.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return {
              id: item.id,
              slug: item.slug,
              ...item.acf,
              videos: textareaTextToArrayWithParams(item.acf.videos),
            };
          });
        }

        if (fetchedData.length === 0) {
          state.other_project = {};
          state.is_fetching_work = false;
          return;
        }

        state.other_project = fetchedData[0];
        state.is_fetching_other_project = false;
      })
      .addCase(fetch_other_project.pending, (state) => {
        state.is_fetching_other_project = true;
      })
      .addCase(fetch_other_project.rejected, (state) => {
        state.is_fetching_other_project = false;
      });
  },
});

export const { setOtherProjects } = otherProjectsSlice.actions;

export default otherProjectsSlice.reducer;
